import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-right\">\n<g id=\"chevron-right_Icon\">\n<path id=\"chevron-right_Vector\" d=\"M9 18L14.6854 12.7071C15.1049 12.3166 15.1049 11.6834 14.6854 11.2929L9 6\" stroke=\"#202325\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol